export enum ResourceRoleEnum {
  "webapp-monitor-source" = "webapp-monitor-source"
}